import { _any } from "i18n";
import type { DiscoverGameMetadataOptionsResponse } from "libs/apiClient";

export function gameTypeLabel(
	gameType: string | null,
	gameTypeOptions?: DiscoverGameMetadataOptionsResponse["gameTypes"],
): string {
	if (gameType === null) {
		return "-";
	}

	const translatedLabel = gameTypeOptions?.find((option) => option.value === gameType)?.label;
	if (translatedLabel != null && translatedLabel !== "") {
		return translatedLabel;
	}

	return _any(gameType);
}
